/**
 * Felder der Bestellpositions-View, deren Bearbeitung im Altclient keinen Editor öffnet,
 * sondern die Container-Sidebar (`SidebarContainer` in `IwmViewBestellposition`).
 *
 * Eigenes Modul, damit die Liste ohne die Sidebar-Abhängigkeit geprüft werden kann.
 */
export const CONTAINER_SIDEBAR_FIELDS: readonly string[] = [
  'Container_Anlieferdatum',
  'Container_AnlieferdatumEmpf',
  'Container_Anlieferuhrzeit',
  'Container_Bemerkung',
  'Container_BLNummer',
  'Container_Containerleerrueckgabe',
  'Container_ContainerNo',
  'Container_ContTyp1',
  'Container_DatumZugestellt',
  'Container_DepotDatum',
  'Container_DepotName',
  'Container_EingangErledigt',
  'Container_Empfaenger',
  'Container_ETA',
  'Container_ETD',
  'Container_FruehestAnlieferdatum',
  'Container_Kw',
  'Container_NaechsteKW',
  'Container_Plombe',
  'Container_PoD',
  'Container_RueckgabeReferenz',
  'Container_Spediteur',
  'Container_TerminBestaetigungCIF1',
];
